"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Button = _interopRequireDefault(require("../Button"));
var _Divider = _interopRequireDefault(require("../Divider"));
var _ButtonGroup = _interopRequireDefault(require("./ButtonGroup.style"));
const _excluded = ["className", "type", "orientation", "withDivider", "classes", "children", "buttonProps", "dataTestId"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const StyledButtonGroup = (0, _reactJss.default)(_ButtonGroup.default)(_ref => {
  let {
      className,
      type,
      orientation,
      withDivider,
      classes,
      children,
      buttonProps,
      dataTestId
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const itemsToRender = (0, _react.useMemo)(() => {
    const buttonstArray = _react.default.Children.toArray(children).filter(child => child !== null && child !== undefined);
    let indexKey = 0;
    return buttonstArray.reduce((acc, button, index) => {
      if (index !== 0 && withDivider) {
        // Insert divider between buttons
        acc.push(/*#__PURE__*/_react.default.createElement(_Divider.default, {
          orientation: orientation,
          key: indexKey,
          className: classes.divider
        }));
        indexKey += 1;
      }
      acc.push(_react.default.cloneElement(button, _objectSpread(_objectSpread(_objectSpread({}, button.props), buttonProps), {}, {
        type: buttonProps.type || type,
        key: indexKey
      })));
      indexKey += 1;
      return acc;
    }, []);
  }, [children, withDivider]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)(className, classes.buttonGroup, classes[`backgroundColor__${buttonProps.type || type}`], classes[`orientation__${orientation}`]),
    "data-testid": dataTestId
  }, props), itemsToRender);
});
const ButtonGroup = props => /*#__PURE__*/_react.default.createElement(StyledButtonGroup, props);
ButtonGroup.TYPE = _Button.default.TYPE;
ButtonGroup.ORIENTATION = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};
ButtonGroup.defaultProps = {
  type: _Button.default.defaultProps.type,
  orientation: ButtonGroup.ORIENTATION.horizontal,
  withDivider: true,
  buttonProps: {}
};
var _default = exports.default = ButtonGroup;